module.exports = __webpack_public_path__ + "img/s2P40.dde5ef96.png";